__turbopack_context__.v({
  "accent": "ClientShowcase-module__qYWYJW__accent",
  "author": "ClientShowcase-module__qYWYJW__author",
  "clientGroup": "ClientShowcase-module__qYWYJW__clientGroup",
  "count": "ClientShowcase-module__qYWYJW__count",
  "details": "ClientShowcase-module__qYWYJW__details",
  "doodle": "ClientShowcase-module__qYWYJW__doodle",
  "gallery": "ClientShowcase-module__qYWYJW__gallery",
  "ghost": "ClientShowcase-module__qYWYJW__ghost",
  "headline": "ClientShowcase-module__qYWYJW__headline",
  "inner": "ClientShowcase-module__qYWYJW__inner",
  "intro": "ClientShowcase-module__qYWYJW__intro",
  "logo": "ClientShowcase-module__qYWYJW__logo",
  "logoImage": "ClientShowcase-module__qYWYJW__logoImage",
  "logoTrack": "ClientShowcase-module__qYWYJW__logoTrack",
  "logos": "ClientShowcase-module__qYWYJW__logos",
  "logos-slide": "ClientShowcase-module__qYWYJW__logos-slide",
  "overlay": "ClientShowcase-module__qYWYJW__overlay",
  "pulse": "ClientShowcase-module__qYWYJW__pulse",
  "pulsePing": "ClientShowcase-module__qYWYJW__pulsePing",
  "quote": "ClientShowcase-module__qYWYJW__quote",
  "section": "ClientShowcase-module__qYWYJW__section",
  "slider": "ClientShowcase-module__qYWYJW__slider",
  "sliderButton": "ClientShowcase-module__qYWYJW__sliderButton",
  "sliderNav": "ClientShowcase-module__qYWYJW__sliderNav",
  "sliderTrack": "ClientShowcase-module__qYWYJW__sliderTrack",
  "sparkle": "ClientShowcase-module__qYWYJW__sparkle",
  "stars": "ClientShowcase-module__qYWYJW__stars",
  "strip": "ClientShowcase-module__qYWYJW__strip",
  "stripLabel": "ClientShowcase-module__qYWYJW__stripLabel",
  "tag": "ClientShowcase-module__qYWYJW__tag",
  "tags": "ClientShowcase-module__qYWYJW__tags",
  "testimonial": "ClientShowcase-module__qYWYJW__testimonial",
  "testimonials": "ClientShowcase-module__qYWYJW__testimonials",
  "tile": "ClientShowcase-module__qYWYJW__tile",
  "tileImage": "ClientShowcase-module__qYWYJW__tileImage",
  "tileLink": "ClientShowcase-module__qYWYJW__tileLink",
  "tileName": "ClientShowcase-module__qYWYJW__tileName",
  "tileResult": "ClientShowcase-module__qYWYJW__tileResult",
  "tileText": "ClientShowcase-module__qYWYJW__tileText",
  "track": "ClientShowcase-module__qYWYJW__track",
  "words": "ClientShowcase-module__qYWYJW__words",
});
